<template>
  <div class="title">
    <div class="title1" :style="{ color: title1Color }">{{ title1 }}</div>
    <div class="line" :style="{ background: color }"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title1Color: this.color,
      time: 60 * 60 * 1000
    };
  },
  props: {
    title1: {
      type: String,
      default: ""
    },
    title2: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#000"
    },
    lineColor: {
      type: String,
      default: "#aa6b01"
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-count-down {
  font-size: 25px;
  font-weight: 600;
  color: #be0000;
}
.title {
  width: 100%;
  height: 100px;
  padding: 10px 0 10px 0;
  text-align: center;
}
.title1 {
  width: 100%;
  height: 40px;
  font-size: 27px;
  font-weight: 900;
  /* color: black; */
}
.title2 {
  width: 100%;
  height: 20px;
  font-size: 17px;
}
.line {
  width: 10%;
  height: 4px;
  /* background: #aa6b01; */
  margin: 15px auto 0 auto;
}
</style>
